import { ENDPOINTS } from '@polyai/stream/endpoints';

import { doDelete, doGet, doPost } from 'api/request';
import { LOGGER_TYPE } from 'api/types';
import { generateNextPath } from 'lib/routeHelper';
import type {
  BranchResponse,
  CreateBranchPayload,
  CreateBranchResponse,
  DeleteBranchPayload,
  DeleteBranchResponse,
  MergeBranchPayload,
  MergeBranchResponse,
} from './types';

export const getBranches = ({
  accountId,
  projectId,
}: {
  accountId: string;
  projectId: string;
}) => {
  return doGet<{
    branches: BranchResponse[];
  }>(
    generateNextPath(ENDPOINTS.BRANCHES, { accountId, projectId }),
    LOGGER_TYPE.JUPITER,
    {
      prefix: 'sourcerer',
    },
  );
};

export const createBranch = ({
  accountId,
  projectId,
  lastKnownSequence,
  branchName,
}: CreateBranchPayload) => {
  return doPost<CreateBranchResponse>(
    generateNextPath(ENDPOINTS.BRANCHES, { accountId, projectId }),
    LOGGER_TYPE.JUPITER,
    {
      expectedMainLastKnownSequence: Number(lastKnownSequence),
      branchName,
    },
    {
      prefix: 'sourcerer',
    },
  );
};

export const mergeBranch = ({
  accountId,
  projectId,
  branchId,
  expectedBranchLastKnownSequence,
  deploymentMessage,
  conflictResolutions = [],
  disableValidation = false,
}: MergeBranchPayload) => {
  const path = generateNextPath(ENDPOINTS.BRANCH_MERGE, {
    accountId,
    projectId,
    branchId,
  });

  // Add query parameter if disableValidation is true
  const url = disableValidation ? `${path}?disableValidation=true` : path;

  return doPost<MergeBranchResponse>(
    url,
    LOGGER_TYPE.JUPITER,
    {
      expectedBranchLastKnownSequence: Number(expectedBranchLastKnownSequence),
      deploymentMessage,
      conflictResolutions,
    },
    {
      prefix: 'sourcerer',
      returnStatusCode: true,
    },
  );
};

export const deleteStreamBranch = ({
  accountId,
  projectId,
  branchId,
  expectedBranchLastKnownSequence,
}: DeleteBranchPayload) => {
  return doDelete<DeleteBranchResponse>(
    generateNextPath(ENDPOINTS.BRANCH, { accountId, projectId, branchId }),
    LOGGER_TYPE.JUPITER,
    {
      expectedBranchLastKnownSequence: Number(expectedBranchLastKnownSequence),
    },
    {
      prefix: 'sourcerer',
    },
  );
};

export const getAccountBranchCounts = ({
  accountId,
}: {
  accountId: string;
}) => {
  return doGet<{
    branchCounts: Record<string, number>;
  }>(
    generateNextPath(ENDPOINTS.ACCOUNT_BRANCH_COUNTS, { accountId }),
    LOGGER_TYPE.JUPITER,
    {
      prefix: 'sourcerer',
    },
  );
};
